import { get } from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  getSiteUsersFailed,
  getSiteUsersSuccess,
  getUsersBySearchFailed,
  getUsersBySearchSuccess,
} from "./actions"
import * as url from "helpers/url_helper"
import { GET_SITE_USERS, GET_USERS_BY_SEARCH } from "./actionTypes"

function* getSiteUsers({ payload: params }) {
  try {
    const response = yield get(url.ADMIN_USER_URL, { params })
    yield put(getSiteUsersSuccess(response))
  } catch (error) {
    yield put(getSiteUsersFailed(error))
    showToast("error", error, "Error")
  }
}

function* getUsersBySearch({ payload: params }) {
  try {
    const response = yield get(url.USER_SEARCH_URL, { params })
    yield put(getUsersBySearchSuccess(response))
  } catch (error) {
    yield put(getUsersBySearchFailed(error))
  }
}

function* siteUsersSaga() {
  yield takeEvery(GET_SITE_USERS, getSiteUsers)
  yield takeEvery(GET_USERS_BY_SEARCH, getUsersBySearch)
}

export default siteUsersSaga
